import React, { useState, useEffect } from "react";
import axios from "axios";
import { environment } from "../../environment.js";
import { Button, Modal } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { Link } from "react-router-dom";
import Loader from "../Components/Loader.js";
import Select from "react-select";
import Toggle from "react-toggle";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { Checkbox, TextareaAutosize, TextField } from "@mui/material";
import { icon } from "@fortawesome/fontawesome-svg-core";
import NavbarNew from "../Components/NavbarNew.js";
const { SearchBar } = Search;

const MySwal = withReactContent(Swal);

const FollowupHistory = ({ history, match, props }) => {
  const [dap_users, setUsers] = useState([]);
  const [dap_firstName, setFirstName] = useState("");
  const [dap_lastName, setLastName] = useState("");
  const [dap_phone, setPhone] = useState("");
  const [dap_email, setEmail] = useState("");
  const [billable, setBillable] = useState(false);
  const [dap_address, setAddress] = useState("");
  const [dap_city, setDapCity] = useState([]);
  const [dap_states, setDapState] = useState([]);
  const [countrycode, setCountryCode] = useState("");
  const [postcountry, setPostCountry] = useState("");
  const [postcity, setPostCity] = useState("");
  const [poststate, setPostState] = useState("");
  const [toggleChecked, setToggleChecked] = useState(false);
  const [loader, setLoader] = useState(true);
  const [show, setShow] = useState(false);
  const [showNote, setShowNote] = useState(false);

  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userPhone, setUserPhone] = useState("");
  const [checkIsActive, setCheckIsActive] = useState(false);

  const handleShow = () => setShow(true);
  const handleShowNote = () => setShowNote(true);
  const handleClose = () => setShow(false);
  const handleCloseNote = () => setShowNote(false);

  const [inputField, setInputFields] = useState({
    lead_executive_id: "",
    label: "",
    package: "",
    date: "",
    billable: false,
    mode: "",
    note: "",
    convergence_percentage: "",
  });

  const [respondsArr, setRespondArr] = useState([]);

  const [packageLabel, setPackageLabel] = useState("");
  const [packagePrice, setPackagePrice] = useState("");
  const [date, setDate] = useState("");
  const [user_billable, setUserBillable] = useState(false);
  const [mode, setMode] = useState("");
  const [note, setNote] = useState("");
  const [convergence_percentage, setConvergencePercentage] = useState("");
  const [respond, setRespond] = useState(false);
  const [goBackLink, setGoBackLink] = useState("");

  // const dap_id = match.params.id;
  const toggle = (e) => {
    setToggleChecked(true);
  };
  useEffect(() => {
    let id = match.params.id;

    if (localStorage.getItem("isLeadExecutive")) {
      setGoBackLink("/follow-up");
    } else {
      setGoBackLink("/addLeads");
    }

    let lead_executive_id = "";
    if (localStorage.getItem("isLeadExecutive")) {
      lead_executive_id = JSON.parse(
        localStorage.getItem("executivedetails")
      )._id;
    } else {
    }

    setRespondArr([
      {
        name: "Responded",
        respond: true,
      },
      {
        name: "Not Responded",
        respond: false,
      },
    ]);

    console.log(id);
    axios
      .get(environment.dap_url + "crm_api/getLeadsById?id=" + id)
      .then((res) => {
        console.log("hii");
        console.log(res.data);
        setUserName(res.data.userFirstName + " " + res.data.userLastName);
        setUserEmail(res.data.email);
        setUserPhone(res.data.phone);
        setCheckIsActive(res.data.isActive);
        setPackageLabel(res.data.package);
        if (lead_executive_id != res.data.lead_executive_id) {
          setCheckIsActive(false);
        } else {
          setCheckIsActive(true);
        }
        // setUserName(data.name)
      });

    axios
      .post(
        environment.dap_url + "crm_api/getFollowUpByLeadExecutiveIdandLeadId",
        {
          lead_executive_id: lead_executive_id,
          lead_id: id,
        }
      )
      .then((res) => {
        const dap_users = res.data;
        console.log("res");
        const data = res.data;
        const sortedData = data.sort(
          (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
        );
        setUsers(sortedData);
        console.log(res.data.length);
        // setPackageLabel(res.data[res.data.length-1].label)
        // setPackagePrice(res.data[res.data.length-1].package)
      })
      .catch(function (error) {
        MySwal.fire({
          title: <p>{error.message}</p>,
          type: "error",
        });
      });
  }, []);

  const showNoteModal = (note) => {
    setNote(note);
    setShowNote(true);
  };

  const setResponded = (e) => {
    console.log(e);
    setRespond(e);
  };

  const selectRow = (index) => {
    console.log(index);
    console.log(dap_users[index]);
    MySwal.fire({
      title: "Are you sure to changed the status?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(
            environment.dap_url +
              "crm_api/changeRespondStatus?id=" +
              dap_users[index]._id
          )
          .then((data) => {
            MySwal.fire({
              title: <p>Status Changed</p>,
              type: "success",
            }).then((result) => {
              window.location.reload();
            });
          });
      }
    });
  };

  const submitHandler = (e) => {
    let id = match.params.id;
    // if(packageLabel==""){
    //   console.log("this field is mandatory");
    // }else if(packagePrice==""){
    //   console.log("this field is mandatory");
    // }else
    if (date == "") {
      console.log("this field is mandatory");
    } else if (mode == "") {
      console.log("this field is mandatory");
    } else if (note == "") {
      console.log("this field is mandatory");
      // }else if(convergence_percentage == ""){
      //   console.log("this field is mandatory");
    } else {
      let reqBody = {
        lead_executive_id: JSON.parse(localStorage.getItem("executivedetails"))
          ._id,
        label: packageLabel,
        package: packagePrice,
        date: date,
        billable: billable,
        mode: mode,
        note: note,
        convergence_percentage: convergence_percentage,
        is_responded: respond,
      };
      console.log(reqBody);
      axios
        .post(environment.dap_url + "crm_api/follow-up?lead_id=" + id, reqBody)
        .then((data) => {
          console.log(data);
          if (data.status == 200) {
            window.location.reload();
          }
        });
    }

    // console.log(reqBody);
  };
  const setCheckbox = (e) => {
    // console.log("hii");
    console.log(e.target.checked);
    setBillable(e.target.checked);
  };

  const columns = [
    {
      dataField: "sl.no",
      text: "Sl no.",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1;
      },
      sort: true,
    },
    {
      dataField: "date",
      text: "Date",
      sort: true,
      formatter: (dataField) => {
        let dateArr = dataField.split("-");
        let date = dateArr[2] + "-" + dateArr[1] + "-" + dateArr[0];
        return date;
      },
    },
    {
      dataField: "note",
      text: "Note",
      sort: true,
      style: {
        maxWidth: "500px",
        padding: "10px",
        overflow: "hidden",
        // overflowWrap: "break-word"
      },
      formatter: (dataField) => {
        var stringNote = "";
        var stringArr = dataField.split(" ");
        var count = 0;
        if (stringArr.length >= 24) {
          for (let i = 0; i < 24; i++) {
            // for(let j=0;j<12;j++){
            stringNote += stringArr[count] + " ";
            count++;
            // }
            // stringNote+='\n'
          }
          return (
            <p>
              {stringNote}{" "}
              <b
                style={{ cursor: "pointer" }}
                className="text-primary"
                onClick={() => showNoteModal(dataField)}
              >
                View More...
              </b>
            </p>
          );
        } else {
          return dataField;
        }

        // return (
        //   <div>
        //     <Button
        //       variant="primary"
        //       className="btn-sm"
        //       onClick={() => showNoteModal(dataField)}
        //     >
        //       Show Note <i className="fa fa-trash-o"></i>
        //     </Button>
        //   </div>
        // )
      },
    },
    {
      dataField: "mode",
      text: "Mode",
      sort: true,
    },
    {
      dataField: "is_responded",
      text: "Status",
      sort: true,

      formatter: (cell, row, rowIndex, dataField) => {
        if (dap_users[rowIndex].is_responded) {
          return (
            <div>
              <Button variant="success" size="sm">
                Responded
              </Button>{" "}
              {/* <span type="button" className="text text-primary"><i className="fa fa-edit "></i>Change</span> */}
            </div>
          );
        } else {
          return (
            <div>
              <Button variant="danger" size="sm">
                Not Responded
              </Button>
              <span
                type="button"
                onClick={(e) => selectRow(rowIndex)}
                className="text text-primary"
                style={{ cursor: "pointer" }}
              >
                <i className="fa fa-edit"></i>Change
              </span>
            </div>
          );
        }
      },
    },

    // {
    //   dataField: "_id",
    //   text: "Delete",
    //   sort: false,
    //   formatter: (dataField) => {
    //     return (
    //       <div>
    //         <Button
    //           variant="danger"
    //           className="btn-sm"
    //           onClick={() => deleteHandler(dataField)}
    //         >
    //           Delete <i className="fa fa-trash-o"></i>
    //         </Button>
    //       </div>
    //     );
    //   },
    // },
  ];

  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ];

  return (
    <div class="container-fluid">
      <NavbarNew />
      <div className="container">
        <div class="col-md-12">
          <Link
            to={goBackLink}
            className="btn btn-light my-3"
            style={{ marginLeft: 990 }}
          >
            Go Back
          </Link>
        </div>
      </div>

      <div>
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <h4 className="card-title">FOLLOW-UP HISTORY</h4>
                {/* <div className="container"> */}
                <p>
                  Name : <b>{userName}</b>
                </p>
                <p>
                  Email : <b>{userEmail}</b>
                </p>
                <p>
                  Phone no : <b>{userPhone}</b>
                </p>
                <p>
                  Package : <b>{packageLabel}</b>
                </p>
                {/* <p>Price : <b>{packagePrice}</b></p> */}
                {/* </div> */}
                <Button
                  className="m-2 btn-small"
                  onClick={handleShow}
                  disabled={!checkIsActive}
                >
                  ADD FOLLOW UP NOTE
                </Button>
                <div className="row">
                  <div className="col-12">
                    <ToolkitProvider
                      keyField="id"
                      bootstrap4
                      data={dap_users}
                      columns={columns}
                      search
                    >
                      {(props) => (
                        <div>
                          <div className="d-flex align-items-center">
                            <p className="mb-2 mr-2">Search in table:</p>
                            <SearchBar {...props.searchProps} />
                          </div>
                          <BootstrapTable
                            defaultSorted={defaultSorted}
                            pagination={paginationFactory()}
                            {...props.baseProps}
                            wrapperClasses="table-responsive"
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add Followup Note</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col">
              <TextField
                label="Date"
                name="date"
                type="date"
                onChange={(e) => setDate(e.target.value)}
                required
              />
            </div>
            <div className="col">
              <TextField
                label="Note"
                name="note"
                type="text"
                onChange={(e) => setNote(e.target.value)}
                required
              />
            </div>
            <div className="col">
              <TextField
                label="Mode"
                name="mode"
                type="text"
                onChange={(e) => setMode(e.target.value)}
                required
              />
            </div>
            <div className="col">
              <Select
                options={respondsArr.map((element) => ({
                  id: element.name,
                  value: element.respond,
                  label: element.name,
                }))}
                onChange={(e) => setResponded(e.value)}
              />
            </div>
          </div>

          {/* <TextField
             label="Package"
             name="label"
             type="text"
             onChange={(e)=>setPackageLabel(e.target.value)}
             required/>
             <TextField
             label="Price"
             name="package"
             type="text"
             onChange={(e)=>setPackagePrice(e.target.value)}
             required/> */}

          {/* <TextField
             label="Convergence"
             name="convergence_percentage"
             type="number"
             onChange={(e)=>setConvergencePercentage(e.target.value)}
             required/> */}
          {/* <Checkbox
             label="Billable"
             name="billable"
             id="billable"
             onClick={(e)=>setCheckbox(e)}
             required
             /> */}
          {/* <label htmlFor="billable">Billable</label> */}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={(e) => submitHandler(e)}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showNote} onHide={handleCloseNote}>
        <Modal.Header closeButton>
          <Modal.Title>Follow Up Note</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className="container"
            style={{ fontSize: "18px", lineHeight: "30px", margin: "10px" }}
          >
            {note}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleCloseNote}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default FollowupHistory;

// ATBBYkhgaSNKrF6NAxkyzDfnbWD615C4FCE9
